export const no = {
  returnLineItems: {
    refund: "Refusjon(er)",
    exchange: "Bytte(r)",
    newOrder: "Ny ordre",
    discount: "Rabatt(er)",
  },
  returnStoreAddress: {
    mapButton: "Vis på kart",
  },
  downloadLabel: {
    label: "Last ned etiketten min",
    bonDeRetour: "Last ned returseddelen min",
  },
  returnRequestDate: {
    label: "Returforespørselen din ble opprettet {{date}} kl. {{time}}",
  },
  actions: {
    continue: "Fortsett",
  },
  "order-identification": {
    title: "Spor bestillingen din",
    description: "Skriv inn bestillingsdetaljene for å spore pakken din",
    fields: {
      "zip-code": {
        title: "Postnummer",
        description: "Skriv inn leveringspostnummeret ditt",
        required: "Postnummer er påkrevd",
      },
      email: {
        title: "E-postadresse",
        description: "Skriv inn e-postadressen du brukte til bestillingen",
        required: "E-postadresse er påkrevd",
      },
      both: {
        title: "Postnummer eller e-post",
        description: "Skriv inn leveringspostnummeret ditt eller e-posten som ble brukt til bestillingen",
        required: "Postnummer eller e-post er påkrevd",
      },
      "tracking-number": {
        title: "Ordrenummer",
        description: "Skriv inn ordrenummeret ditt",
        required: "Ordrenummer er påkrevd",
      },
    },
    errors: {
      "unknown-order": {
        title: "Ukjent ordrenummer",
        description: "Ordrenummeret ble ikke funnet, vennligst sjekk det",
      },
      "search-error": {
        title: "Søkefeil",
        description:
          "Vi kunne ikke finne bestillingen. Vennligst prøv igjen senere.",
      },
    },
  },
  delivery: "Levering",
  "parcel-history": "Pakkehistorikk",
  "order-details": {
    title: "Ordredetaljer",
    "tracking-number": "Sporingsnummer",
    "order-number": "Ordrenummer",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Forventet leveringsdato",
      deliveredOn: "Levert den",
      from: "fra",
      to: "til",
    },
  },
  deliveryAddress: {
    title: "Leveringsadresse:",
    titlePickup: "Adresse til hentested:",
    orderDetails: {
      title: "Ordredetaljer:",
      trackingNumber: "Sporingsnummer:",
      orderNumber: "Ordrenummer:",
      orderDate: "Ordredato:",
    },
  },
  pickupPoint: {
    title: "Hentested",
    openingHours: "Åpningstider:",
    closed: "Stengt",
    directions: "Veibeskrivelse",
    days: {
      monday: "Mandag:",
      tuesday: "Tirsdag:",
      wednesday: "Onsdag:",
      thursday: "Torsdag:",
      friday: "Fredag:",
      saturday: "Lørdag:",
      sunday: "Søndag:",
    },
  },
  wallet: {
    warningNotEnabled: "Du må aktivere Wallet i butikkinnstillingene dine",
  },
  crossSell: {
    youMightAlsoLike: "Du vil kanskje også like",
  },
  "rate-order": {
    "order-recap": {
      title: "Din bestilling",
      "tracking-label": "Sporingsnummer:",
      "order-label": "Ordrenummer:",
    },
    form: {
      title: "Vurder leveringen din",
      "rating-label": "Vurder leveringsopplevelsen din",
      "comment-label": "Kommentar (valgfritt)",
      "comment-placeholder": "Del opplevelsen din med oss…",
      "submit-cta": "Send inn vurderingen min",
      "update-cta": "Oppdater vurderingen min",
      "rating-required": "Vennligst velg en vurdering.",
    },
    "thank-you": {
      title: "Takk for tilbakemeldingen!",
      description:
        "Vurderingen din er lagret. Den vil hjelpe oss med å forbedre leveringsopplevelsen.",
    },
    errors: {
      "invalid-token": {
        title: "Ugyldig eller utløpt lenke",
        description:
          "Denne lenken er ikke lenger gyldig. Åpne den på nytt fra din siste sporings-e-post.",
      },
      submit: {
        title: "Noe gikk galt",
        description:
          "Vi kunne ikke lagre vurderingen din. Vennligst prøv igjen senere.",
      },
    },
  },
  shippingInstructions: {
    colissimo: "Du kan nå skrive ut returetiketten din og levere pakken på nærmeste Colissimo-innleveringssted.",
    chronoShop2Shop: "Du kan nå skrive ut returetiketten din og levere pakken på nærmeste Chronopost-innleveringssted.",
    ups: "Du kan nå skrive ut returetiketten din og levere pakken på nærmeste UPS-innleveringssted.",
    fedex: "Skriv ut hele PDF-filen, og fest bare fraktetiketten på pakken. Handelsfakturaen og fraktbrevkopiene trengs til tollbehandlingen: ikke legg dem inne i pakken, men lever dem sammen med pakken på FedEx-stedet eller til sjåføren, som legger dem i dokumentlommen.",
    customerCarrier: "Du kan nå sende returpakken til transportøren du ønsker.",
    merchantCarrier: "Vi sender deg en returetikett på e-post innen 1 til 3 virkedager.",
    returnToStore: "Du kan nå levere pakken i nærmeste butikk.",
    malca: "Du kan nå skrive ut returetiketten din og levere pakken på nærmeste Malca-innleveringssted.",
    tnt: "Du kan nå skrive ut returetiketten din og levere pakken på nærmeste TNT-innleveringssted.",
    bonDeRetour: "Fraktetiketten din er klar. Du kan nå skrive den ut og bruke den til returen.",
    unknownCarrier:
      "Du kan nå skrive ut returetiketten din og sende pakken med transportøren som er angitt på etiketten.",
  },
  shippingInstructionsTitle: {
    shippingLabel: "Fraktetiketten din er klar",
    bonDeRetour: "Returseddelen din er klar",
  },
} as const;
